/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
/* Services */

/**
 * Renders No Data Component 
 * @returns {ReactElement} - No Data Component
 */
export default function NoData() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      p="30px 0px"
    >
      <Text
        w="100%"
        textAlign="center"
        fontSize="18px"
        fontWeight="500"
        lineHeight="1.25"
        color="#d33100"
        fontFamily="FedraSansStd-Medium"
      >
        No Data Found
      </Text>
    </Box>
  );
}
